<template>
  <div>
    <el-row v-for="(item,key) in linkageData" :key="key" style=" margin-top: 20px;">
      <el-col :lg="12" :md="11" :sm="10" :xl="12" :xs="10" style="text-align: center; ">联动{{ item.appName }}：</el-col>
      <el-col :lg="12" :md="13" :sm="14" :xl="12" :xs="14" style="text-align: center;">
        <el-switch
          style="display: block;  "
          v-model=item.autoApprove
          active-color="#13ce66"
          @touchstart.native="checkVariable(item)"
          @click.native="checkVariable(item)"
          inactive-color="#ff4949"
          inactive-text="禁用"
          active-text="启用"
          active-value="true"
          inactive-value="false"
        >
        </el-switch>

      </el-col>
    </el-row>

  </div>
</template>

<script>
import {getCheckUrl} from "@/network/systematic";

export default {
  name: "EditLinkage",
  props: {
    linkageData: {},
    linkage:[]
  },
  methods: {
    checkVariable(item) {
      this.$emit('event' ,false);
      if (item.autoApprove === 'true') {
        getCheckUrl(item).then(res => {
          this.linkage = res.code;
          this.$emit('event' ,true);
          if (res.code === -1) {
            item.autoApprove=false;
            this.$message({
              message: res.message,
              type: 'error'
            });
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
